<!-- error message -->
<div *ngIf="isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
    <p>{{'FRONT_USER.ERRORS_MESSAGES.InternalServerError' | translate}}</p>

  </div>
</div>
<div *ngIf="!isErrorMessage">
  <h2 class="sectionTitle">{{ 'SHARED.REPORTS.EBOOKING_REPORT.INCOMPLETE_TASKS' | translate }}</h2>
  <div class="services-filter">

        <div class="form-container">
            <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
              <div class="form-group"
                title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}">
                <label for="textTransitDate">{{ 'SHARED.REPORTS.EBOOKING_REPORT.TRANSIT_DATE' | translate}}</label>
                <input class="form-control" id="textTransitDate" name="textTransitDate" autocomplete="off"
                    #input="bsDatepicker" [(ngModel)]="transitDate" bsDatepicker [minDate]='null'
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour}">
            </div>

            <!-- Sail Directions -->
            <div class="form-group"
                title="{{ 'SHARED.REPORTS.EBOOKING_REPORT.FeesEstimationAndTransitservicesFilterOnly' | translate }}">
                <label for="ddlSailDirections">{{ 'SHARED.REPORTS.EBOOKING_REPORT.DIRECTIONS' | translate}}</label>
                <select [(ngModel)]=" this.directionId" class="form-control" id="ddlSailDirections">
                    <option value="">--- {{'SHARED.REPORTS.EBOOKING_REPORT.ALL_DIRECTIONS' | translate}} ---</option>
                    <option *ngFor="let direction of sailDirections" value="{{direction?.Id}}">
                        {{lang == "Ar" ? direction?.DirectionAR : direction?.Direction}}
                    </option>
                </select>
            </div>


















        </div>

        <div class="btns-holder text-center">
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadEBookingReport()"
                value="{{ 'SHARED.Search' | translate}}" />
            <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetMyEBookingReport()"
                value="{{ 'SHARED.ResetSearch' | translate}}" />

        </div>
    </div>
  <div>
    <div title="Page Count" [style.float]="lang=='En' ? 'right' : 'left'">
      <label for="ddlPageCount">Page Size: </label>
      <select (change)="changeCount($event)" id="ddlPageCount">
        <option value="15">15</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select>
    </div>
  </div>
  <div class="noMenu-table">
    <!-- <app-grid-view #MyAgents [IsHtml]="IsHtml" [HasMenu]="HasMenu" (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view> -->

    <app-grid-view #EBookingReport [customMenuTemplate]="reportListTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"
      (loadItemsMenu)="loadItemsMenu($event)"></app-grid-view>

    <ng-template #reportListTemplate let-item let-menuItems="menuItems">


      <li role="menuitem">
        <a class="dropdown-item" (click)="getPendingTask(item.RequestId)">
          {{'FRONT_USER.PENDING_TASKS'|translate}}
        </a>
      </li>
      <li role="menuitem" >
        <a class="dropdown-item" (click)="getFeesByTransitId(item.RequestId)">
          {{'FRONT_USER.FEES_DETAILS'|translate}}
        </a>
      </li>


    </ng-template>
  </div>
</div>
